/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import addBureauActions, {
    addBureauTypes,
} from '../../../redux/bureau/addBureau'
import getAllBureauxActions from '../../../redux/bureau/getAllBureaux'
import alertActions from '../../../redux/alert'
import { Post } from '../../../serveur/axios'

function* addBureauSagas({ response }) {
    try {
        const res = yield Post('bureauemploi/', response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(addBureauActions.addBureauSuccess(res.data)),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
                yield put(addBureauActions.addBureauSuccess(null)),
                yield put(
                    getAllBureauxActions.getAllBureauxRequest()
                ),
            ])
        } else {
            yield put(addBureauActions.addBureauFailure(res))
        }
    } catch (error) {
        yield put(addBureauActions.addBureauFailure(error))
    }
}

export function* addBureauSaga() {
    yield takeLatest(
        addBureauTypes.ADD_BUREAU_REQUEST,
        addBureauSagas
    )
}
